import { createContext } from "react";
import { ImagesDTO } from "../DTOs/ImagesDTO"; 
import logoB2B from '../../src/assets/logo/logo_b2b.jpg';
import logoVitrola from '../../src/assets/logo/logo_vitrola.jpg';

type LogoKeys = 'logo_b2b.jpg' | 'logo_vitrola.jpg'; 

const LOGOS: Record<LogoKeys, string> = {
  'logo_b2b.jpg': logoB2B,
  'logo_vitrola.jpg': logoVitrola,
};
 
type ImageContextType = {
    images: ImagesDTO;
    alterarLogo: (path: string) => void,
};

const logoName = process.env.REACT_APP_LOGONAME! as LogoKeys;

const finalLogoPath = LOGOS[logoName]; 

export const imageInitial = {
    Logo: finalLogoPath 
};

const imageContext = createContext<ImageContextType>({
    images: imageInitial as ImagesDTO, 
    alterarLogo: (path: string) => {}
});


export default imageContext;